



































import Vue from "vue";
import { VueTableRequest, OrderApi, OrderFulfillmentTableDto } from "@/api";
import stateMixin from "@/mixins/state";
import { toLocalDateTimeString } from "@/util/date";

export default Vue.extend({
  data() {
    return {
      data: {},
      headers: [
        { text: "Afdeling", value: "facility" },
        { text: "Patienten", value: "patientCount" },
        { text: "Bags", value: "bagCount" },
        { text: "Status", value: "reelStatusText" },
        { text: "Besteldatum", value: "orderDate", align: "right" }
      ],
      options: {
        sortBy: ["orderDate"],
        sortDesc: [true],
        page: 1,
        itemsPerPage: 20
      }
    };
  },
  name: "PackagingOrders",
  mixins: [stateMixin],
  methods: {
    toLocalDateTimeString,
    fetch: async function() {
      this.setState(this.states.LOADING);
      const api = new OrderApi();
      try {
        const request: VueTableRequest = {
          sortBy: this.options.sortBy,
          descending: this.options.sortDesc,
          page: this.options.page,
          rowsPerPage: this.options.itemsPerPage,
          search: ""
        };
        const { data } = await api.orderGetOrderFulfillmentsTable(request);
        this.data = data as OrderFulfillmentTableDto;
        this.setState(this.states.INITIAL);
      } catch {
        this.setState(this.states.ERROR);
      }
    }
  },
  watch: {
    options: {
      handler() {
        this.fetch();
      },
      deep: true,
      immediate: false
    }
  }
});
